import { Action } from '@ngrx/store';
import { Update } from '@ngrx/entity';
import { AzureBlobStorage, AzureBlobStorageParam } from '../azure-blob-storage.model';
import { BlobClient } from '@azure/storage-blob';

export enum AzureBlobStorageActionTypes {
  GetDownLoadAzureBlobStorages = '[AzureBlobStorage] Get Download AzureBlobStorages',
  DownloadAzureBlobStoragesSuccess = '[AzureBlobStorage] Download AzureBlobStorages',
  GetUploadAzureBlobStorages = '[AzureBlobStorage] Get Upload AzureBlobStorage',
  UploadAzureBlobStoragesSuccess = '[AzureBlobStorage] Upload AzureBlobStorage',
  GetAzureBlobStoragesSASToken = '[AzureBlobStorage] Get AzureBlobStorages SAS Token',
  AddAzureBlobStoragesSASToken = '[AzureBlobStorage] Add AzureBlobStorages SAS Token'
}

export class GetDownLoadAzureBlobStorages implements Action {
  readonly type = AzureBlobStorageActionTypes.GetDownLoadAzureBlobStorages;

  constructor(public payload: AzureBlobStorageParam) {}
}

export class DownloadAzureBlobStoragesSuccess implements Action {
  readonly type = AzureBlobStorageActionTypes.DownloadAzureBlobStoragesSuccess;

  constructor(public payload: { azureBlobStorages: BlobClient, action: string }) {}
}

export class GetUploadAzureBlobStorages implements Action {
  readonly type = AzureBlobStorageActionTypes.GetUploadAzureBlobStorages;

  constructor(public payload: AzureBlobStorageParam) {}
}

export class UploadAzureBlobStoragesSuccess implements Action {
  readonly type = AzureBlobStorageActionTypes.UploadAzureBlobStoragesSuccess;

  constructor(public payload: { azureBlobStorages: BlobClient, action: string }) {}
}

export class GetAzureBlobStoragesSASToken implements Action {
  readonly type = AzureBlobStorageActionTypes.GetAzureBlobStoragesSASToken;

  constructor(public payload: any = null) {}
}

export class AddAzureBlobStoragesSASToken implements Action {
  readonly type = AzureBlobStorageActionTypes.AddAzureBlobStoragesSASToken;

  constructor(public payload: string) {}
}

export type AzureBlobStorageActions =
GetDownLoadAzureBlobStorages
 | DownloadAzureBlobStoragesSuccess
 | GetUploadAzureBlobStorages
 | UploadAzureBlobStoragesSuccess
 | GetAzureBlobStoragesSASToken
 | AddAzureBlobStoragesSASToken;
